export default "__VITE_ASSET__BGqx2k$M__"